// extracted by mini-css-extract-plugin
export default {"globalPreviewPromotionScale":"2.4","loadingIcon":"_loading_loadingIcon_UHDZs","md-menu-content":"_loading_md-menu-content_Qf1Rq"};